export default __webpack_public_path__ + "static/media/products-5-m.34c60b60.webp";